import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const ContactsForm = () => {
  const { t, language } = useLanguage();

  const [form, setForm] = useState({
    nome: '',
    email: '',
    siteEmpresa: '',
    emailCorporativo: '',
    orcamento: '',
    pais: '',
    descricao: '',
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  // Lista de países com nomes em português e inglês
  const countries = [
    { code: '', pt: t('contactForm.fields.country'), en: t('contactForm.fields.country') },
    { code: 'AF', pt: 'Afeganistão', en: 'Afghanistan' },
    { code: 'AX', pt: 'Ilhas Alanda', en: 'Åland Islands' },
    { code: 'AL', pt: 'Albânia', en: 'Albania' },
    { code: 'DZ', pt: 'Argélia', en: 'Algeria' },
    { code: 'AS', pt: 'Samoa Americana', en: 'American Samoa' },
    { code: 'AD', pt: 'Andorra', en: 'Andorra' },
    { code: 'AO', pt: 'Angola', en: 'Angola' },
    { code: 'AI', pt: 'Anguila', en: 'Anguilla' },
    { code: 'AQ', pt: 'Antártida', en: 'Antarctica' },
    { code: 'AG', pt: 'Antígua e Barbuda', en: 'Antigua and Barbuda' },
    { code: 'AR', pt: 'Argentina', en: 'Argentina' },
    { code: 'AM', pt: 'Armênia', en: 'Armenia' },
    { code: 'AW', pt: 'Aruba', en: 'Aruba' },
    { code: 'AU', pt: 'Austrália', en: 'Australia' },
    { code: 'AT', pt: 'Áustria', en: 'Austria' },
    { code: 'AZ', pt: 'Azerbaijão', en: 'Azerbaijan' },
    { code: 'BS', pt: 'Bahamas', en: 'Bahamas' },
    { code: 'BH', pt: 'Bahrein', en: 'Bahrain' },
    { code: 'BD', pt: 'Bangladesh', en: 'Bangladesh' },
    { code: 'BB', pt: 'Barbados', en: 'Barbados' },
    { code: 'BY', pt: 'Bielorrússia', en: 'Belarus' },
    { code: 'BE', pt: 'Bélgica', en: 'Belgium' },
    { code: 'BZ', pt: 'Belize', en: 'Belize' },
    { code: 'BJ', pt: 'Benim', en: 'Benin' },
    { code: 'BM', pt: 'Bermudas', en: 'Bermuda' },
    { code: 'BT', pt: 'Butão', en: 'Bhutan' },
    { code: 'BO', pt: 'Bolívia', en: 'Bolivia, Plurinational State of' },
    { code: 'BQ', pt: 'Bonaire, Santo Eustáquio e Saba', en: 'Bonaire, Sint Eustatius and Saba' },
    { code: 'BA', pt: 'Bósnia e Herzegovina', en: 'Bosnia and Herzegovina' },
    { code: 'BW', pt: 'Botsuana', en: 'Botswana' },
    { code: 'BV', pt: 'Ilha Bouvet', en: 'Bouvet Island' },
    { code: 'BR', pt: 'Brasil', en: 'Brazil' },
    { code: 'IO', pt: 'Território Britânico do Oceano Índico', en: 'British Indian Ocean Territory' },
    { code: 'BN', pt: 'Brunei', en: 'Brunei Darussalam' },
    { code: 'BG', pt: 'Bulgária', en: 'Bulgaria' },
    { code: 'BF', pt: 'Burquina Faso', en: 'Burkina Faso' },
    { code: 'BI', pt: 'Burundi', en: 'Burundi' },
    // ... (adicione mais países conforme necessário) ...
    { code: 'PT', pt: 'Portugal', en: 'Portugal' },
    { code: 'ES', pt: 'Espanha', en: 'Spain' },
    { code: 'US', pt: 'Estados Unidos', en: 'United States' },
    { code: 'GB', pt: 'Reino Unido', en: 'United Kingdom' },
    { code: 'FR', pt: 'França', en: 'France' },
    { code: 'DE', pt: 'Alemanha', en: 'Germany' },
    { code: 'IT', pt: 'Itália', en: 'Italy' },
    { code: 'JP', pt: 'Japão', en: 'Japan' },
    { code: 'CN', pt: 'China', en: 'China' },
    { code: 'IN', pt: 'Índia', en: 'India' },
    { code: 'RU', pt: 'Rússia', en: 'Russian Federation' },
    { code: 'ZA', pt: 'África do Sul', en: 'South Africa' },
    { code: 'MX', pt: 'México', en: 'Mexico' },
    { code: 'CA', pt: 'Canadá', en: 'Canada' },
    { code: 'AU', pt: 'Austrália', en: 'Australia' },
    { code: 'AR', pt: 'Argentina', en: 'Argentina' },
    { code: 'CL', pt: 'Chile', en: 'Chile' },
    { code: 'CO', pt: 'Colômbia', en: 'Colombia' },
    { code: 'PE', pt: 'Peru', en: 'Peru' },
    { code: 'UY', pt: 'Uruguai', en: 'Uruguay' },
    { code: 'VE', pt: 'Venezuela', en: 'Venezuela, Bolivarian Republic of' },
    { code: 'KR', pt: 'Coreia do Sul', en: 'Korea, Republic of' },
    { code: 'TW', pt: 'Taiwan', en: 'Taiwan, Province of China' },
    { code: 'SG', pt: 'Singapura', en: 'Singapore' },
    { code: 'IL', pt: 'Israel', en: 'Israel' },
    { code: 'TR', pt: 'Turquia', en: 'Turkey' },
    { code: 'SA', pt: 'Arábia Saudita', en: 'Saudi Arabia' },
    { code: 'EG', pt: 'Egito', en: 'Egypt' },
    { code: 'NG', pt: 'Nigéria', en: 'Nigeria' },
    { code: 'KE', pt: 'Quênia', en: 'Kenya' },
    { code: 'GH', pt: 'Gana', en: 'Ghana' },
    { code: 'AO', pt: 'Angola', en: 'Angola' },
    { code: 'MZ', pt: 'Moçambique', en: 'Mozambique' },
    { code: 'CV', pt: 'Cabo Verde', en: 'Cape Verde' },
    { code: 'ST', pt: 'São Tomé e Príncipe', en: 'Sao Tome and Principe' },
    { code: 'GW', pt: 'Guiné-Bissau', en: 'Guinea-Bissau' },
    { code: 'TL', pt: 'Timor-Leste', en: 'Timor-Leste' },
    // ...
  ];
const sanitizeInput = (input) => {
  if (!input) return '';
  // Remove characters that could be used for XSS attacks
  const sanitized = input.replace(/[<>&"']/g, '');
  return sanitized;
};
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let sanitizedValue = value;

    if (type === 'text' || type === 'email' || type === 'textarea') {
      sanitizedValue = sanitizeInput(value);
    }

    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : sanitizedValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(null);
    setError(null);
    try {
      // Concatenar os campos extras em description
      const description = [
        form.emailCorporativo && `Work Email: ${form.emailCorporativo}`,
        form.orcamento && `Budget: ${form.orcamento}`,
        form.pais && `Country: ${form.pais}`,
        form.descricao && `Message: ${form.descricao}`,
      ].filter(Boolean).join(' | ');
      const payload = {
        firstName: form.nome,
        email: form.email,
        website: form.siteEmpresa,
        description,
      };
      const response = await fetch('https://pre-endback-a15c98f29747.herokuapp.com/api/lead', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error('Erro ao enviar formulário');
      setSuccess('Enviado com sucesso!');
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', {'send_to': 'AW-16946885349/n3wNCLC_vIIbEOXl85A_'});
      }
      setForm({
        nome: '',
        email: '',
        siteEmpresa: '',
        emailCorporativo: '',
        orcamento: '',
        pais: '',
        descricao: '',
      });
    } catch (err) {
      setError('Erro ao enviar. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className='col-xl-5 col-lg-7 col-md-12 order-0 order-lg-1'>
        <div className='register-wrap p-5 bg-white shadow rounded-custom mt-5 mt-lg-0 mt-xl-0'>
          <h3 className='fw-medium h4'>
            {t('contactForm.title')}
          </h3>

          <form action='#' className='mt-4 register-form' onSubmit={handleSubmit}>
            {success && <div className='alert alert-success'>{success}</div>}
            {error && <div className='alert alert-danger'>{error}</div>}
            <div className='row'>
              <div className='col-sm-6'>
                <div className='input-group mb-3'>
                  <input
                    type='text'
                    className='form-control'
                    placeholder={t('contactForm.fields.name')}
                    aria-label='name'
                    name='nome'
                    value={form.nome}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className='col-sm-6 '>
                <div className='input-group mb-3'>
                  <input
                    type='email'
                    className='form-control'
                    placeholder={t('contactForm.fields.email')}
                    aria-label='email'
                    name='email'
                    value={form.email}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className='col-sm-6'>
                <div className='input-group mb-3'>
                  <input
                    type='text'
                    className='form-control'
                    placeholder={t('contactForm.fields.companyWebsite')}
                    aria-label='company-website'
                    name='siteEmpresa'
                    value={form.siteEmpresa}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className='col-sm-6'>
                <div className='input-group mb-3'>
                  <input
                    type='email'
                    className='form-control'
                    placeholder={t('contactForm.fields.workEmail')}
                    aria-label='work-Email'
                    name='emailCorporativo'
                    value={form.emailCorporativo}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className='col-sm-6'>
                <div className='input-group mb-3'>
                  <select
                    className='form-control form-select'
                    name='orcamento'
                    id='budget'
                    required=''
                    data-msg='Please select your budget.'
                    value={form.orcamento}
                    onChange={handleChange}
                  >
                    <option value=''>{t('contactForm.fields.budgetOptions.default')}</option>
                    <option value='started'>{t('contactForm.fields.budgetOptions.started')}</option>
                    <option value='less20k'>{t('contactForm.fields.budgetOptions.less20k')}</option>
                    <option value='less50k'>{t('contactForm.fields.budgetOptions.less50k')}</option>
                    <option value='less100k'>{t('contactForm.fields.budgetOptions.less100k')}</option>
                    <option value='less500k'>{t('contactForm.fields.budgetOptions.less500k')}</option>
                    <option value='more500k'>{t('contactForm.fields.budgetOptions.more500k')}</option>
                  </select>
                </div>
              </div>
              <div className='col-sm-6'>
                <div className='input-group mb-3'>
                  <select
                    className='form-control form-select'
                    name='pais'
                    id='country'
                    required=''
                    data-msg='Please select your country.'
                    value={form.pais}
                    onChange={handleChange}
                  >
                    {countries.map((country) => (
                      <option key={country.code} value={country.code}>
                        {language === 'pt' ? country.pt : country.en}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className='col-12'>
                <div className='input-group mb-3'>
                  <textarea
                    className='form-control'
                    placeholder={t('contactForm.fields.message')}
                    style={{ height: '120px' }}
                    name='descricao'
                    value={form.descricao}
                    onChange={handleChange}
                  ></textarea>
                </div>
              </div>
              {/* <div className='col-12'>
                <div className='form-check'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    value='1'
                    id='flexCheckChecked'
                    name='privacy'
                    checked={form.privacy}
                    onChange={handleChange}
                  />
                  <label
                    className='form-check-label small'
                    htmlFor='flexCheckChecked'
                  >
                    {t('contactForm.privacy.text')}
                    <Link to='#'> {t('contactForm.privacy.link')}</Link>.
                  </label>
                </div>
              </div> */}
              <div className='col-12'>
                <button
                  type='submit'
                  className='btn btn-primary mt-4 d-block w-100'
                  disabled={loading}
                >
                  {loading ? t('contactForm.sending') || 'Enviando...' : t('contactForm.submit')}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ContactsForm;
